module.exports = __webpack_public_path__ + "static/media/people.5b76cb72.svg";